'use strict';

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _titleSection = require('../common/title-section');

var _titleSection2 = _interopRequireDefault(_titleSection);

var _bodySection = require('../common/body-section');

var _bodySection2 = _interopRequireDefault(_bodySection);

var _ctaSection = require('../common/cta-section');

var _ctaSection2 = _interopRequireDefault(_ctaSection);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

module.exports = _react2['default'].createClass({
    displayName: 'Electronic Signature SEO Page',

    renderTitleSection: function renderTitleSection() {
        var titleSectionProps = {
            title: 'HelloSign\'s Guide To Electronic Signatures',
            subtitle: 'Jump in and try electronic signing for yourself! Click here to create your free HelloSign account.',
            buttonText: 'LET\'S DO IT!'
        };
        return _react2['default'].createElement(_titleSection2['default'], _extends({}, titleSectionProps, this.props));
    },
    renderBodySection: function renderBodySection() {
        var headerClass = 'm-marketing-page--header';
        var listClass = 'm-marketing-page--list';
        return _react2['default'].createElement(
            _bodySection2['default'],
            null,
            _react2['default'].createElement(
                'h2',
                { className: headerClass },
                'What is an electronic signature?'
            ),
            _react2['default'].createElement(
                'p',
                null,
                'According to the ',
                _react2['default'].createElement(
                    'a',
                    {
                        href: 'http://www.techlawjournal.com/cong106/digsig/Default.htm',
                        target: '_blank', rel: 'noopener noreferrer' },
                    'U.S. Federal ESIGN Act'
                ),
                ' passed in 2000, an electronic signature is an "electronic sound, symbol, or process, attached to or logically associated with a contract or other record and executed or adopted by a person with the intent to sign the record."'
            ),
            _react2['default'].createElement(
                'p',
                null,
                'In layman\'s terms, an electronic signature, often referred to as an e-signature, is a person\'s electronic expression of his or her agreement to the terms of a particular document.'
            ),
            _react2['default'].createElement(
                'h2',
                { className: headerClass },
                'What are electronic signatures used for?'
            ),
            _react2['default'].createElement(
                'p',
                null,
                'Electronic signatures are used on every sort of document you can imagine. For instance, ',
                _react2['default'].createElement(
                    'a',
                    { href: '/', target: '_blank', rel: 'noopener noreferrer' },
                    'HelloSign'
                ),
                ' users use electronic signatures to:'
            ),
            _react2['default'].createElement(
                'ul',
                { className: listClass },
                _react2['default'].createElement(
                    'li',
                    null,
                    'Esign NDAs, timesheets, and employee onboarding paperwork'
                ),
                _react2['default'].createElement(
                    'li',
                    null,
                    'Esign sales contracts, invoices, and approve proposals'
                ),
                _react2['default'].createElement(
                    'li',
                    null,
                    'Fill out and sign leases and other rental and housing agreements'
                ),
                _react2['default'].createElement(
                    'li',
                    null,
                    'Electronically sign tax documents, bank forms, and insurance paperwork'
                ),
                _react2['default'].createElement(
                    'li',
                    null,
                    'Fill out and sign permission slips, school forms, and release'
                )
            ),
            _react2['default'].createElement(
                'h2',
                { className: headerClass },
                'How do electronic signatures work with HelloSign?'
            ),
            _react2['default'].createElement(
                'p',
                null,
                'There are ',
                _react2['default'].createElement(
                    'a',
                    { href: 'http://blog.hellosign.com/signature-maker',
                        target: '_blank', rel: 'noopener noreferrer' },
                    '4 ways to create an electronic signature'
                ),
                ' using HelloSign.'
            ),
            _react2['default'].createElement(
                'ul',
                { className: listClass },
                _react2['default'].createElement(
                    'li',
                    null,
                    'Draw your signature using your computer mouse or touchpad'
                ),
                _react2['default'].createElement(
                    'li',
                    null,
                    'Take a photo of your signature using your smartphone and upload it to HelloSign'
                ),
                _react2['default'].createElement(
                    'li',
                    null,
                    'Type your name and select any one of our fonts to give your typed signature an authentic touch'
                ),
                _react2['default'].createElement(
                    'li',
                    null,
                    'Sign using your finger either on our mobile app for iOS and Android, or using our in-person signing feature on the iPad'
                )
            ),
            _react2['default'].createElement(
                'p',
                null,
                'Once created, an electronic signature can be added to any document along with other annotations such as check marks or freeform text.'
            ),
            _react2['default'].createElement(
                'div',
                { className: 'text-center l-padding-t-60' },
                _react2['default'].createElement('img', {
                    src: require('images/info/signature_modal@2x.png'),
                    alt: 'Signature Modal',
                    className: 'm-marketing-page--image-signature-modal'
                })
            ),
            _react2['default'].createElement(
                'h2',
                { className: headerClass },
                'Are electronic signatures legal?'
            ),
            _react2['default'].createElement(
                'p',
                null,
                'Yes, ',
                _react2['default'].createElement(
                    'a',
                    {
                        href: 'http://blog.hellosign.com/esignatures-legal-handwritten-signatures',
                        target: '_blank', rel: 'noopener noreferrer' },
                    'electronic signatures are valid and legal'
                ),
                ' in the United States, Canada, the European Union, the UK, and many other areas of the world. View more about the legality ofelectronic signatures ',
                _react2['default'].createElement(
                    'a',
                    {
                        href: '/info/legal', target: '_blank', rel: 'noopener noreferrer' },
                    'here'
                ),
                '.'
            ),
            _react2['default'].createElement(
                'h2',
                { className: headerClass },
                'What are the benefits of electronic signatures?'
            ),
            _react2['default'].createElement(
                'p',
                null,
                'There are many benefits to using an electronic signature. Using electronic signatures through HelloSign you can:'
            ),
            _react2['default'].createElement(
                'ul',
                { className: listClass },
                _react2['default'].createElement(
                    'li',
                    null,
                    'Get documents signed fast'
                ),
                _react2['default'].createElement(
                    'li',
                    null,
                    'Sign documents from anywhere'
                ),
                _react2['default'].createElement(
                    'li',
                    null,
                    'Collect ',
                    _react2['default'].createElement(
                        'a',
                        { href: 'http://blog.hellosign.com/are-esignatures-secure',
                            target: '_blank', rel: 'noopener noreferrer' },
                        'secure and legally binding signatures'
                    )
                ),
                _react2['default'].createElement(
                    'li',
                    null,
                    'And ',
                    _react2['default'].createElement(
                        'a',
                        { href: '/info/benefits', target: '_blank', rel: 'noopener noreferrer' },
                        'many more'
                    )
                )
            )
        );
    },
    renderCTASection: function renderCTASection() {
        var ctaSectionProps = {
            title: 'Get started: eSign a document for free',
            subtitle: 'Ready to dive in and try electronic signing for yourself? Want to see more?',
            signupButtonText: 'SIGN UP FOR A HELLOSIGN ACCOUNT',
            signupButtonUrl: this.props.homeUrl,
            secondButtonText: 'SEE PRO PLANS',
            secondButtonUrl: this.props.pricingUrl,
            apiUsersHeaderText: 'OUR HAPPY USERS',
            embeddedTweetsHeaderText: 'SOCIAL LOVE'
        };
        return _react2['default'].createElement(_ctaSection2['default'], _extends({}, ctaSectionProps, this.props));
    },
    render: function render() {
        return _react2['default'].createElement(
            'div',
            null,
            this.renderTitleSection(),
            this.renderBodySection(),
            this.renderCTASection()
        );
    }
});


/*****************
 ** WEBPACK FOOTER
 ** ./src/landing-pages/components/seo/electronic-signature.jsx
 ** module id = 1225
 ** module chunks = 0
 **/